import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './ClientHeader.scss';
import cn from 'classnames';
import { ROOT_URL } from 'constants/Config';

import { loadCollection } from 'actions/collections';
import { setPopUp } from 'actions/environment';
import languageIcon from 'assets/images/icons/language-icon.svg';

import RealtorPopup from 'components/RealtorPopup';
import Avatar from 'components/common/Avatar';
import Footer from './Footer';

import iconBack from 'assets/images/icons/icon-back-white.svg';
import { withTranslation } from 'react-i18next';
import LanguageModal from 'components/Language/LanguageModal';

class ClientHeader extends Component {
  showPopup = () => {
    this.props.setPopUp(<RealtorPopup {...this.props.user} />, {
      closeStyleName: 'Default',
      contentStyleName: 'Default',
      closeIcon: 'default',
      closeClassName: styles.PopupCompanyClose,
      backgroundClassName: styles.PopupCompanyBg,
      contentClassName: styles.PopupCompanyContent,
      lockScroll: true,
    });
  };

  handleOpenLanguageModal = () =>
    this.props.setPopUp(<LanguageModal />, {
      closeStyleName: 'Default',
      contentStyleName: 'Default',
      closeIcon: 'default',
      lockScroll: false,
    });

  render() {
    const { user = {}, t, currentLanguage, i18n } = this.props;
    const { agency = {} } = user;
    const { name, logoId, color = '#2B313B' } = agency;

    return (
      <div className={styles.ClientWrapper}>
        <style>{'#root > div {padding-top: 0;}'}</style>
        <div className={cn(styles.HeaderCollections)} style={{ background: color }}>
          <div className={styles.Container}>
            {name ? (
              <div className={styles.AgencyBlock}>
                <div className={styles.AgencyAvatar}>
                  <Avatar
                    className={styles.AgencyAvatarImage}
                    image={
                      logoId ? `${ROOT_URL}/image/get?id=${logoId}&preset=profile_avatar` : null
                    }
                  />
                </div>
                <p className={styles.AgencyName}>{name}</p>
              </div>
            ) : null}
            <button className={styles.LanguageButton} onClick={this.handleOpenLanguageModal}>
              <img className={styles.LanguageIcon} src={languageIcon} />
            </button>

            {
              // Бугага!
              (document.location.pathname.includes('map') ||
                document.location.pathname.includes('building')) && (
                <div className={styles.BackToList}>
                  <a href={`/collection/view/${this.props.params.referal}`}>
                    <img src={iconBack} alt="" />
                    <span>{t('components.header.clientHeader.backToList')}</span>
                  </a>
                </div>
              )
            }
          </div>
        </div>
        {this.props.children}
        <Footer agency={agency} />
      </div>
    );
  }
}

export default connect((state) => ({ ...state.collection }), { loadCollection, setPopUp })(
  withTranslation()(ClientHeader)
);



// WEBPACK FOOTER //
// ./src/components/Header/ClientHeader/ClientHeader.js